import React, { useState, useEffect } from 'react';
import {msgclose} from './message';
const CountdownTimer = (initialsec:any) => {
  const [seconds, setSeconds] = useState(10);
  const [isRunning, setIsRunning] = useState(false);
 

  useEffect(() => {
    let interval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 100);
    if (isRunning && seconds > 0) {
      interval = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
    } else if (seconds === 0) {
      clearInterval(interval);
      setIsRunning(false);
      msgclose();
      // Optional: Add a callback or action when the timer finishes
      //console.log("Timer finished!");
    }
    return () => clearInterval(interval); // Cleanup on component unmount or dependency change
  }, [isRunning, seconds]);

  const startTimer = () => {
    setIsRunning(true);
  };

  const pauseTimer = () => {
    setIsRunning(false);
  };

  const resetTimer = () => {
    setIsRunning(false);
  };

  return (
    <div style={{display:'none'}}>
      
    </div>
  );
};
export default CountdownTimer;
